import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import line from "../../assets/line.png";
import business02_1 from "../../assets/business02_1.jpg";
import business02_2 from "../../assets/business02_2.jpg";

function Busi_security() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div id="sub" className="mission">
        <div className="cont-wr">
          <div className="wr">
            <div className="cont-tit">
              <h2 className="big">보안컨설팅</h2>
              <div className="cont-tit">
                <h2>"모의해킹으로 증명된 효과적 보안 대책제시"</h2>
              </div>
              <div className="wr">
                <p className="des">
                  보안 컨설팅 전문가 그룹과 다수의 프로젝트로 부터 검증된 컨설팅
                  방법론을 기반으로 정보보호관리 과정과 절차를
                  <br className="pc-only" />
                  체계적으로 수립하고 지속적인 보안관리 운영방안을 제시함으로써
                  고객의 정보서비스에 <br className="pc-only" />
                  대한 가치와 신뢰도를 높여드리겠습니다.
                </p>
                <div className="center">
                  <div className="img center">
                    <img src={business02_1} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="cont-wr">
            <div className="wr">
              <div
                className="img center"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                <div className="cont-tit">
                  <div className="img center">
                    <img src={line} alt="" />
                  </div>
                  <h2 className="big">모의해킹</h2>
                  <div className="cont-tit">
                    <h2>
                      "정보자산의 보안 취약점을 악용한 침투 가능 경로를 파악하여
                      보안 사고를 예방"
                    </h2>
                  </div>
                  <div className="wr">
                    <p className="des">
                      고객의 정보자산 및 애플리케이션 보안 취약점 진단 결과를
                      바탕으로 모의 행킹 목표를 수립하고 침투 가능성을
                      분석합니다.
                      <br className="pc-only" />
                      분석된 침투 경로에 따라 모의해킹 시나리오를 구성하고, 수행
                      결과에 따라 고객의 취약점 노출 및 정보자산 서비스 영향을
                      최소화하기 위한 통제 방안을 마련합니다.
                      <br className="pc-only" />
                      모의해킹은 시나리오에 따라 철저한 통제하에 수행되고,
                      모의해킹을 증명된 침투 경로에 대한 효과적인 보안대책을
                      제시합니다.
                    </p>
                    <div className="center">
                      <img src={business02_2} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Busi_security;
